/*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
export var AttributeNames = /*#__PURE__*/function (AttributeNames) {
  AttributeNames["EVENT_TYPE"] = "event_type";
  AttributeNames["TARGET_ELEMENT"] = "target_element";
  AttributeNames["TARGET_XPATH"] = "target_xpath";
  AttributeNames["HTTP_URL"] = "http.url";
  return AttributeNames;
}(AttributeNames || {});

